import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route navigation always lands at the top of the destination page.
 * Hash navigation (e.g. /#galeri-design) is left to the target page so the
 * intentional in-page scroll still works.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};
